angular.module('dnecom')
    .controller('BraintreeIntegrationsModalController', ["$scope", "$http", "notifications", "WindowUtils", function($scope, $http, notifications, WindowUtils) {
        $scope.authorizing = false;
        $scope.timeout = null;

        function scheduleCheck() {
            $scope.timeout = setInterval($scope.check, 3000);
        }

        function descheduleCheck() {
            clearInterval($scope.timeout);

            $scope.timeout = null;
        }

        $scope.authorize = function() {
            $scope.authorizing = true;

            var openedWindow = WindowUtils.openBlank('about:blank', {
                width: 860,
                height: 590
            });

            openedWindow.document.write('Waiting for response...');
            openedWindow.document.close();

            $http.post(Routing.generate('integrations_braintree_authorize', {
                'id': $scope.account.id
            }), $scope.account)
                .then(function(response) {
                    if (!response.data.success || !response.data.authUrl) {
                        openedWindow.close();
                        notifications.danger(response.data.message || 'Unknown error.');
                        $scope.authorizing = false;
                        return;
                    }

                    openedWindow.location.href = response.data.authUrl;
                    scheduleCheck();
                }, function() {
                    openedWindow.close();
                    $scope.authorizing = false;
                    notifications.danger('Request error.');
                });
        };

        $scope.cancelAuthorization = function() {
            descheduleCheck();
            $scope.closeModal();
        }

        $scope.check = function() {
            $http.get(Routing.generate('integrations_braintree_check_status', {
                'id': $scope.account.id
            })).then(function(response) {
                if (!response.data.success || $scope.timeout === null) {
                    return;
                }

                descheduleCheck();
                $scope.account = response.data.account;
                $scope.authorizing = false;
                $scope.resolveModal($scope.account);
            }, function() {
                notifications.danger('Request error.')
            });
        }
    }]);
